import React, { useState } from 'react';
import imgI from '../../../img/logo 1.png';
import { Link, useNavigate } from 'react-router-dom';
import Log from './Logs.module.css';
import { loginAdmin } from '../../../Api/PostManApi';

const AdminLog = () => {
    const [email, setEmail] = useState('');
    const [pass, setPass] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        try {
            const data = await loginAdmin(email, pass);
            localStorage.setItem('token', data.token);
            navigate('/Admin/AdminBoard'); // Redirect after successful login
        } catch (error) {
            setError(error.message);
        }
    };

    return (
        <div className={Log.Log}>
            <div className={Log.container}>
                <div className={Log.content}>
                    <div className={Log.logo}>
                        <img src={imgI} alt="Logo" />
                    </div>
                    <div className={Log.block}>
                        <div className={Log.seci}>
                            <h3>Welcome</h3>
                            <p>Register your account to access your dashboard and modify your dashboard activities.</p>
                        </div>
                        {error && <p className={Log.error}>{error}</p>}
                        <form onSubmit={handleSubmit}>
                            <div className={Log.email}>
                                <label htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={email}
                                    id="email"
                                    placeholder="Enter your Email"
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                            <div className={Log.pass}>
                                <label htmlFor="pass">Password</label>
                                <input
                                    type="password"
                                    name="pass"
                                    id="pass"
                                    value={pass}
                                    onChange={(e) => setPass(e.target.value)}
                                    required
                                />
                            </div>
                            <div className={Log.secii}>
                                <button type="submit">Sign In</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminLog;
